import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthConfigModule } from './core/auth/auth-config.module';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { HomeComponent } from './components/home/home.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { AuthInterceptor } from 'angular-auth-oidc-client';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DaoService } from './core/dao/dao.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TaskCreatorComponent } from './components/task/task.creator/task.creator.component';
import { TaskCreatorTileComponent } from './components/task/task.creator/task.creator.tile/task.creator.tile.component';
import { TaskViewerComponent } from './components/task/task.viewer/task.viewer.component';
import { TaskViewerTileComponent } from './components/task/task.viewer/task.viewer.tile/task.viewer.tile.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './core/material.module';
import { DaoInterceptor } from './core/dao/dao.interceptor';
import { ProcessingComponent } from './components/processing/processing.component';
import { AsyncService } from './core/async/async.service';
import { AsyncDialogComponent } from './core/async/dialog/async.dialog.component';
import { DragndropDirective } from './core/directives/dragndrop.directive';
import { AsyncAlertComponent } from './core/async/alert/async.alert.component';
import { TaskViewerTileDetailsComponent } from './components/task/task.viewer/task.viewer.tile/task.viewer.tile.details/task.viewer.tile.details.component';
import { DaoErrorInterceptor } from './core/dao/dao.error.interceptor';
import { SyncComponent } from './components/sync/sync.component';
import { TaskSelectorComponent } from './components/task/task.selector/task.selector.component';
import { SettingsComponent } from './components/settings/settings.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { FilterTasksPipe } from './components/task/task.viewer/task.viewer.pipes';
import { TaskCreatorNameComponent } from './components/task/task.creator/task.creator.name/task.creator.name.component';
import {
  DxSelectBoxModule, DxTextBoxModule, DxDataGridModule, DxBulletModule, DxTemplateModule, DxHtmlEditorModule,
} from 'devextreme-angular';
import { AdminComponent } from './components/admin/admin.component';
import { AuthAdminGuard } from './core/auth/auth-admin.guard';
import { AdminPluginDetailGridComponent } from './components/admin/admin.plugin.detail/admin.plugin.detail.component';
import { AdminUserDetailGridComponent } from './components/admin/admin.user.detail/admin.user.detail.component';
import { AdminUserTaskDetailGridComponent } from './components/admin/admin.user.detail/admin.user.task.detail/admin.user.task.detail.component';
import { TaskCreatorInfoComponent } from './components/task/task.creator/task.creator.info/task.creator.info.component';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AuthConfigModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatProgressBarModule,
    FontAwesomeModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxTemplateModule,
    DxDataGridModule,
    DxBulletModule,
    DxHtmlEditorModule,
    NgxUiLoaderModule.forRoot({
      fgsColor: 'white',
      pbColor: 'white',
      fgsType: "double-bounce",
      fgsSize: 70
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    })],
  declarations: [
    //Pipes
    FilterTasksPipe,

    //Components
    DragndropDirective,
    AppComponent,
    ForbiddenComponent,
    HomeComponent,
    NavigationComponent,
    UnauthorizedComponent,
    ProcessingComponent,
    TaskSelectorComponent,
    TaskCreatorComponent,
    TaskCreatorTileComponent,
    TaskCreatorNameComponent,
    TaskCreatorInfoComponent,
    TaskViewerComponent,
    TaskViewerTileComponent,
    AsyncDialogComponent,
    AsyncAlertComponent,
    TaskViewerTileDetailsComponent,
    SyncComponent,
    SettingsComponent,
    AdminComponent,
    AdminPluginDetailGridComponent,
    AdminUserDetailGridComponent,
    AdminUserTaskDetailGridComponent
  ],

  providers: [
    { provide: 'googleTagManagerId', useValue: "G-YQX094SY4Q" },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DaoErrorInterceptor, multi: true },
    DaoService,
    AsyncService,
    AuthAdminGuard],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class AppModule { }
